import { api } from "./api";

export const GET_PLAN_PAYMENTS = async () => {
    const { data } = await api.get(`/payments/plans`)
    return data;
}

export const GET_STRIPE_CONFIGS = async (origin: "awaz" | "company" = "awaz") => {
    const { data } = await api.get(`/payments/stripe/${origin}/configs`)
    return data;
}

export const SAVE_PAYMENT_METHOD = async (
    origin: "awaz" | "company" = "awaz",
    data,
    customer,
) => {
    const { data: dt } = await api.post(`/payments/${origin}/payment/method`, {
        data,
        customer,
        type: origin,
    })
    return dt;
}

export const DELETE_PAYMENT_METHOD = async (paymentMethodId: string) => {
    const { data } = await api.delete(`/payments/company/payment/method/${paymentMethodId}`)
    return data;
}

export const REFUND_PAYMENT = async (id: string, value) => {
    const { data } = await api.post(`/payments/${id}/refund`, { value })
    return data;
}

export const INVOICE_PAYMENT = async (id: string) => {
    const { data } = await api.get(`/payments/${id}/stripe/invoice`)
    return data;
}
